import { analyticEvent, overlayEvent } from './common';

const unsubEmailText = 'my preference center: unsubscribe from all emails button';
export const unsubscribeFromAllEmail = analyticEvent(unsubEmailText);
export const unsubscribeFromAllEmailSuccess = analyticEvent('mktg pref:email list>n');

export const confirmOverlay = overlayEvent('please confirm your unsubscribe request');
